<template>
  <div class="newsletter-new">
    <div class="page-help">
      <div class="txt">
        <p>{{ $t("newHome.stayTuned") }}</p>
        <h2>{{ $t("newHome.newsletterTitle") }}</h2>
      </div>
      <div class="wrapp-input-newsletter">
        <input
          type="text"
          v-model="email"
          :placeholder="$t('newHome.enterEmail')"
        />
        <button class="btn newsletter" @click="setNewsletter">
          {{ $t("newHome.inform") }}
          <img src="../../assets/newImges/arrowUpRight.svg" alt="go" />
        </button>
        <TurnStile :resetToken="resetToken" @set-token="setToken" />
      </div>
    </div>
  </div>
</template>
<script>
import { api } from "@/api";
import { mapState } from "vuex";
// import TurnStile from "../components/TurnStileVue2.vue";
import TurnStile from "@/components/TurnStileVue2.vue";

export default {
  name: "Footer",
  components: {
    TurnStile
  },
  data() {
    return {
      email: "",
      localToken: "",
      resetToken: false
    };
  },
  methods: {
    async setNewsletter() {
      // await this.$recaptchaLoaded();
      // let token = await this.$recaptcha("newsletter");

      const params = {
        token: this.localToken,
        email: this.email
      };
      this.resetToken = !this.resetToken;

      api
        .setNewsletter(params)
        .then(res => {
          this.email = "";
          this.$toast.success(this.$t("main.newsletterSuccess"), {
            duration: 8000
          });
        })
        .catch(e => {
          console.log(e);
          this.$toast.error(this.$t("main.newsletterError"), {
            duration: 8000
          });
        });
    },
    setToken(e) {
      this.localToken = e;
    }
  }
};
</script>
<style lang="scss" scoped>
.newsletter-new {
  width: 100%;
  height: 716px;
  background-color: $light-blue-600;
  font-family: Outfit;
  display: flex;
  justify-content: center;
  align-items: center;

  .txt {
    max-width: 650px;
    margin: auto;
    p {
      font-weight: 400;
      font-style: Regular;
      font-size: 20px;
      line-height: 100%;
      letter-spacing: 0%;
      text-align: center;
      color: $blue-1000;
    }
    h2 {
      font-weight: 500;
      font-style: Medium;
      font-size: 50px;
      line-height: 55px;
      letter-spacing: 0%;
      text-align: center;
      color: $blue-600;
    }
  }
  .wrapp-input-newsletter {
    box-sizing: border-box;
    width: 513px;
    height: 77px;
    margin: auto;
    background-color: $gray-blue-100;
    border-radius: 10px;
    padding-top: 16px;
    padding-right: 28px;
    padding-bottom: 16px;
    padding-left: 28px;
    justify-content: space-between;
    border-width: 1px solid $gray-blue-600;
    display: flex;
    align-items: center;
    text-align: left;

    input {
      border: none;
      outline: none;
      height: 100%;
      font-weight: 400;
      font-size: 18px;
      line-height: 24px;
      letter-spacing: 0%;
      color: $blue-1000;
    }
    input::placeholder {
      font-weight: 500;
      font-style: Medium;
      font-size: 18px;
      line-height: 100%;
      letter-spacing: 0%;

      color: $gray-blue-1300;
    }
    .btn.newsletter {
      background-color: $blue-600;
      min-width: 170px;
      height: 45px;
      font-weight: 500;
      font-style: Medium;
      font-size: 20px;
      line-height: 100%;
      letter-spacing: 0%;
      border-radius: 10px;

      img {
        margin-left: 10px;
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  .newsletter-new {
    width: 100%;
    height: fit-content;
    padding-top: 70px;
    padding-bottom: 70px;

    .txt {
      max-width: 650px;
      margin: auto;
      box-sizing: border-box;
      p {
        font-size: 18px;
      }
      h2 {
        font-size: 30px;
        line-height: 35px;
      }
    }
    .wrapp-input-newsletter {
      box-sizing: border-box;
      width: 100%;

      background-color: $gray-blue-100;
      border-radius: 10px;
      // padding-right: 14px;
      // padding-left: 14px;
      padding: 10px;
      height: fit-content;

      input {
        font-size: 14px;
        line-height: 14px;
        letter-spacing: 0%;
        color: $blue-1000;
        // width: calc(100% - 150px);
        width: calc(100%);
      }
      .btn.newsletter {
        min-width: 100px;
        font-size: 14px;
        padding: 6px !important;

        img {
          margin-left: 2px;
        }
      }
    }
  }
}
</style>
